import { defineMessages } from 'react-intl';

export default defineMessages({
    creditCardNumeber: {
        id: 'platform.paymentdetails.credit-card-auto-details.Credit card number',
        defaultMessage: 'Credit Card Number',
    }
});
